import * as Sentry from '@sentry/react';

/**
 * Routes that render the IF viewer. They are canvas-heavy (deck.gl/VIV):
 * Sentry's Replay watches every DOM mutation and the viewer is a full-screen
 * canvas, so recording it costs pan/zoom time and buys nothing. The viewer also
 * churns through range requests for tiles, which is exactly the kind of traffic
 * that becomes noise in error telemetry.
 *
 * Sentry is therefore disabled on these routes rather than merely toned down.
 */
export const IF_VIEWER_PATH_SEGMENTS = [
  '/if_viewer/',
  '/shared_if_slides/',
  '/if_slides/',
];

export const isIFViewerPage = (pathname = window.location.pathname) =>
  IF_VIEWER_PATH_SEGMENTS.some((segment) => pathname.includes(segment));

let replayStoppedForIFViewer = false;

/**
 * Sentry is initialized once at boot, so a hard load of an IF viewer URL never
 * starts it (see src/index.js). When the viewer is opened through client-side
 * navigation instead, Session Replay is already recording and cannot be
 * un-initialized - stop it so it never records the viewer. Replay stays off for
 * the rest of that tab's session.
 */
export const onSentryRouteChange = (pathname) => {
  if (!isIFViewerPage(pathname) || replayStoppedForIFViewer) return;

  replayStoppedForIFViewer = true;

  const client = Sentry.getCurrentHub().getClient();
  const replay =
    client && client.getIntegrationById && client.getIntegrationById('Replay');

  if (replay) {
    replay.stop();
  }
};

// Exposed for tests: the "already stopped" flag is module state.
export const resetSentryRouteState = () => {
  replayStoppedForIFViewer = false;
};
